export default __webpack_public_path__ + "static/media/change-password.48ccb403.svg";